<script>
  export let message = '';
  export let type = 'is-primary';
  export let show = true;

  const close = function (event) {
    show = false
  }
</script>
<style>

</style>

<div class="notification {type}" class:is-hidden={!show}>
  <button class="delete" on:click={close}></button>
  {message}
</div>